var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donate"},[_c('router-link',{staticClass:"note box dashed",attrs:{"to":"/support"}},[_c('p',[_vm._v("Our members help us stay on the air. Donate now!")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }